import { RootStackRoutes } from 'types';
import { FeatureModule } from '../earn';
import en from './i18n/en.json';
import zhCn from './i18n/zh-CN.json';
import zhHk from './i18n/zh-HK.json';
import jaJp from './i18n/ja-JP.json';
import { BillPaymentNavigator, BillPaymentStackRoutes } from './payment.navigator';

const BillPaymentApp: FeatureModule = {
  name: RootStackRoutes.BillPayment,
  version: '1.0.0',
  hooks: {},
  screens: {
    main: BillPaymentNavigator
  },
  routes: {
    [BillPaymentStackRoutes.Landing]: {
      path: '/landing'
    },
    [BillPaymentStackRoutes.Instruction]: {
      path: '/instruction'
    },
    [BillPaymentStackRoutes.Form]: {
      path: '/form'
    },
    [BillPaymentStackRoutes.FormSchedule]: {
      path: '/form-schedule'
    },
    [BillPaymentStackRoutes.Confirmation]: {
      path: '/confirmation'
    },
    [BillPaymentStackRoutes.Success]: {
      path: '/success'
    },
    [BillPaymentStackRoutes.OtpConfirmation]: {
      path: '/otp-confirmation'
    }
  },
  i18n: {
    en: en as Record<string, any>,
    'zh-HK': zhHk as Record<string, any>,
    'zh-CN': zhCn as Record<string, any>,
    'ja-JP': jaJp as Record<string, any>
  }
};

export default BillPaymentApp;
